import axios from "axios";
import Keycloak from "keycloak-js";

export const axiosInstance = axios.create();

export const addTokenRefreshInterceptors = (keycloak: Keycloak) => {
  // Request interceptor to refresh the token if it will be expired soon
  axiosInstance.interceptors.request.use(
    async (config) => {
      config.headers.Authorization = `Bearer ${keycloak.token}`;

      return config;
    },
    (error) => error,
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (!error.response) {
        console.error("CORS ERROR");

        // infinite loop'u engellemek için kontrol
        if (window.location.pathname !== "/maintenance") {
          window.location.href = "/maintenance";
        }

        return Promise.reject(error);
      }
      // If the error status is 401 and there is no originalRequest._retry flag,
      // it means the token has expired and we need to refresh it
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          await keycloak.updateToken(-1);
          originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
          return axios(originalRequest);
        } catch {
          keycloak.logout();
        }
      } else if (error?.response?.status === 401 && originalRequest._retry) {
        // If the error status is 401 and the originalRequest._retry flag is set,
        // it means the token has expired and the refresh token request has failed
        // We need to logout the user
        keycloak.logout();
      } else if (error?.response?.status === 400) {
        // Get the error message from the response metadata
        // and set it as the error message to show in the UI
        if (error?.response?.data?.metadata?.message) {
          error.message = error.response.data.metadata.message;
          error.statusCode = error.response?.status;
        }
      }

      return error;
    },
  );
};

export const setAxiosLanguage = (lang: string) => {
  axiosInstance.defaults.headers.common["Accept-Language"] = lang;
};
